import { NgModule } from "@angular/core";
import { MenuModule } from "../menu/menu.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { ERTKr998Component } from "./ert-kr998.component";
import { ErtKr998ViewComponent } from "./ert-kr998-view/ert-kr998-view.component";
import { FileUploadComponent } from "../shared/file-upload/file-upload.component";
import { ErtNewKr998Component } from "./ert-new-kr998/ert-new-kr998.component";
import { ErtEditKr998Component } from "./ert-edit-kr998/ert-edit-kr998.component";
import { ErtAddAdditionalUserComponent } from "./ert-kr998-view/ert-add-additional-user/ert-add-additional-user.component";
import { ErtKr998UpdateAttendanceComponent } from "./ert-kr998-view/ert-kr998-update-attendance/ert-kr998-update-attendance.component";
import { ErtKr998ErtUsersEditComponent } from "./ert-kr998-view/ert-kr998-ert-users-edit/ert-kr998-ert-users-edit.component";
import { ErtKr998ertusersDetailsComponent } from "./ert-kr998-view/ert-kr998-ertusers-details/ert-kr998-ertusers-details.component";
import { NewKr998AddCrewComponent } from "./ert-new-kr998/new-kr998-add-crew/new-kr998-add-crew.component";

const componentList = [
  ERTKr998Component,
  ErtKr998ViewComponent,
  ErtNewKr998Component,
  NewKr998AddCrewComponent,
  ErtEditKr998Component,
  ErtAddAdditionalUserComponent,
  ErtKr998UpdateAttendanceComponent,
  ErtKr998ErtUsersEditComponent,
  ErtKr998ertusersDetailsComponent
];

@NgModule({
  imports: [MenuModule, SharedImportsModule, TableControlsComponent],
  declarations: [componentList],
})
export class ERTKR998Module {}
